export const isNumber = (variableToCheck)=>{
    try {
        return variableToCheck !== null && variableToCheck.toExponential !== undefined;
    } catch (e) {
        return false;
    }
};
